import { type FC } from "react";
import { LuLogOut } from "react-icons/lu";
import type { ButtonProps } from "@chakra-ui/react";

import { Button } from "@/components/ui/button";

import { useAuthenticationContext } from "@app/auth/use-authentication-context";

export const LogoutButton: FC<ButtonProps> = (props) => {
  const { logOut } = useAuthenticationContext();

  return (
    <Button colorPalette="red" {...props} onClick={() => logOut()}>
      <LuLogOut />
      Logout
    </Button>
  );
};
